// extracted by mini-css-extract-plugin
export default {"platform-filter-header":"templates-market-parity-insight-historical-module__platform-filter-header"};